export const BILLING_PERIODS_VALIDATION_RULES = {

  startDate: {
    isRequiredTrim: {
      value: true,
    },
    lowerThan: {
      value: {
        field: "endDate",
        customMessageKey: "validation.customMessages.startDate",
      },
    },
  },
  endDate: {
    isRequiredTrim: {
      value: true,
    },
    higherThan: {
      value: {
        field: "startDate",
        customMessageKey: "validation.customMessages.endDate",
      },
    },
  },

  creditsInvoiceFrequency: {
    isRequiredTrim: {
      value: true
    },
    regex: {
      value: {
        pattern: /^\d*$/,
        customMessageKey: "validation.customMessages.numeric",
      },
    }
  },

  creditsInvoiceCount: {
    regex: {
      value: {
        pattern: /^\d*$/,
        customMessageKey: "validation.customMessages.numeric",
      },
    }
  },

  startWithdrawalDate: {
    isRequiredTrimIfField: {
      value: {
        field: "hasWithdrawalPeriod",
      },
    },
    lowerThan: {
      value: {
        field: "endWithdrawalDate",
        customMessageKey: "validation.customMessages.startDate",
      },
    },
  },
  endWithdrawalDate: {
    isRequiredTrimIfField: {
      value: {
        field: "hasWithdrawalPeriod",
      },
    },
    higherThan: {
      value: {
        field: "startWithdrawalDate",
        customMessageKey: "validation.customMessages.endDate",
      },
    },
  },

  relatedBillingPeriodId: {
    isRequiredTrimIfField: {
      value: {
        field: "preservePreviousCoverages",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/billingPeriods/billingPeriodValidationRules.js